/**
 * @generated SignedSource<<32d0a86f759fbf374aeb4ffab38fdaf5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespShippingReturns_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespPricingGuidance_user" | "PdpSharedBuyerProtectionBox_user" | "PdpSharedDetailShipping_user">;
  readonly " $fragmentType": "PdpRespShippingReturns_user";
};
export type PdpRespShippingReturns_user$key = {
  readonly " $data"?: PdpRespShippingReturns_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespShippingReturns_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespShippingReturns_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyerProtectionBox_user"
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespPricingGuidance_user"
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "eeee51466f305070ee9d9a6dfab9738c";

export default node;
